import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {AuthenticationService} from '../../_services';
import {TranslateService} from '@ngx-translate/core';

// JS-1802: an existing account accepts an invitation to join an additional agency
@Component({
  moduleId: module.id,
  selector: 'app-join-agency',
  templateUrl: `../views/join-agency.component.html`,
  styleUrls: ['../styles/auth-style.scss'],
  providers: [ MessageService ]
})
export class JoinAgencyComponent implements OnInit {
  token = null;
  email = '';
  role = '';
  agencyName = '';
  clientName = '';
  // JS-1802: client invites get their own wording on the congratulations screen
  isClientInvite = false;
  loaded = false;
  linkInvalid = false;
  joined = false;
  joining = false;
  // JS-1802: auto-join failed — fall back to the manual confirm button as a retry path
  autoJoinFailed = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.token = this.route.snapshot.params.token;
  }

  ngOnInit() {
    this.authService.getEmailFromToken(this.token).subscribe(response => {
      this.loaded = true;
      if (!response.email) {
        this.linkInvalid = true;
        this.translate.get('This link is expired').subscribe(res => {
          this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
        return;
      }
      if (!response.existing_user) {
        // no account for this email — this is a normal registration invite
        this.router.navigate(['/staff/register/' + this.token]);
        return;
      }
      this.email = response.email;
      this.role = response.role;
      this.agencyName = response.agency_name;
      this.clientName = response.client_name;
      this.isClientInvite = !!(response.role && response.role.toLowerCase().includes('client'));
      if (response.language) {
        this.translate.use(response.language);
        localStorage.setItem('Language', response.language);
      }
      // JS-1802: clicking the email button IS the confirmation — join instantly
      // instead of showing the confirm screen.
      this.confirm();
    }, () => {
      this.loaded = true;
      this.linkInvalid = true;
    });
  }

  confirm() {
    if (this.joining) { return; }

    this.joining = true;
    this.autoJoinFailed = false;
    this.authService.acceptInvitation(this.token).subscribe(response => {
      if (response.status === 'success') {
        this.joined = true;
      } else {
        this.joining = false;
        this.autoJoinFailed = true;
      }
    }, () => {
      this.joining = false;
      this.autoJoinFailed = true;
    });
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
